'use strict';

// put social data in array
function putSIDataInArray ($element, data, id) {
  var total = 0;
  var medias = {};
  var tmp = {
    url: $element.find('h4').text(),
    id: id
  };

  $element.find('.part.text p').each(function () {
    var thisTmp = $(this);
    var val = parseInt(thisTmp.find('.big-right-aligned-content').text(), 10);
    var name = thisTmp.find('.big-right-aligned').text();

    if (!isNaN(val) && name !== '') {
      medias[name] = val;
      total += val;
      return total;
    }
  });

  tmp.medias = medias;
  tmp.total = total;
  data[tmp.url] = tmp;
  return data;
}

module.exports = putSIDataInArray;
